import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const resetPasswordSlice = createApi({
    reducerPath: "resetPassword",
    baseQuery: fetchBaseQuery({
        baseUrl: "https://brand-logistics.demo.permute.in",
        prepareHeaders: (headers, { getState }) => {
            const token = localStorage.getItem("authToken");
            if (token) {
                headers.set("authorization", "Bearer " + token);
            }
            return headers;
        },
    }),
    endpoints: (builder) => ({
        resetPassword: builder.mutation({
            query: (data) => ({ url: "/auth/api/v1/reset-password", method: "POST", body: data }),
        }),
    }),
});

export const { useResetPasswordMutation } = resetPasswordSlice;
